export const STRINGS = {
  btnNext: 'Étape suivante',
  btnConnect: 'Se connecter',
  btnBack: 'Retour',
  waitingHeading: (prenom: string) => `${prenom}, nous créons votre Espace...`,
  waitingSubtitle: 'Vos identifiants ont été envoyés sur votre email',
  waitingExplain1:
    'En vous connectant, vous trouverez <b>toutes les informations</b> et <b>démarches personnalisées</b> de récupération permis de conduire.',
  waitingExplain2:
    'Vous recevrez les disponibilités de test psychotechnique sur votre département avant votre visite médicale.',
  // Variante onboarding (espace candidat connecté, pas de création de compte)
  waitingHeadingOnboarding: (prenom: string) =>
    prenom
      ? `Merci ${prenom}, nous enregistrons votre situation...`
      : 'Merci, nous enregistrons votre situation...',
  waitingSubtitleOnboarding: 'Votre tableau de bord va s\'ouvrir dans quelques instants',
  waitingExplain1Onboarding:
    'Vous y retrouverez vos <b>démarches personnalisées</b> et les <b>disponibilités de test psychotechnique</b> dans votre département.',
  emailExists: 'Vous avez déjà un Espace Candidat sur notre site.',
  inscriptionPreTitle: 'Retrouvez toutes vos démarches',
  inscriptionTitle: 'Connectez-vous à votre espace',
  inscriptionSubTitle: 'Votre mot de passe vous a été envoyé par <span>email</span>.',
  inscriptionConnected: 'Votre espace candidat a été créé',
  inscriptionRedirect: 'Vous allez être redirigé dans quelques instants...',
  loginInvalidCredentials: "L'email ou le mot de passe est incorrect. Vérifiez vos identifiants.",
  loginNetworkError: 'Erreur réseau. Réessayez.',
  situationTitle: 'Votre Situation',
  demarchesTitle: 'Vos Démarches',
  testsTitle: 'Les tests psychotechniques dans votre département',
  cerfaTitle: 'Téléchargez votre CERFA',
  cerfaSubtitle: 'Retrouvez votre CERFA pré-rempli',
  cerfaSpace: 'Dans votre Espace Candidat',
  medecinsTitlePrefecture: 'Demande de rendez-vous en commission médicale',
  medecinsTitleAgrees: 'Les médecins agréés dans votre département',
  antsTitle: 'Récupérez votre permis de conduire',
  antsSubtitle: "Retrouvez le tutoriel de demande de nouveau permis sur l'ANTS",
  articlesTitle: "Plus d'informations sur votre situation",
  legal: `AAAEP, SAS au capital de 1.200,00 €, immatriculée au registre de commerce et des sociétés d'EVRY sous le numéro 791 132 012, dont le siège social est situé Centre Commercial des Jardins de Concy à Yerres (91330). AAAEP est enregistré auprès de C&C — médiation 37, rue des chênes 25480 MISEREY-SALINES. En cas de litige, le consommateur pourra déposer sa réclamation sur le site <a href="https://www.cc-mediateurconso-bfc.fr/" target="_blank" rel="noopener">https://www.cc-mediateurconso-bfc.fr/</a> qui tentera, en toute indépendance et impartialité, de rapprocher les parties en vue d'aboutir à une solution amiable. © 2026`,
  proAccessSite: 'Accéder au site dédié aux professionnels',
  placeholderDepartement: 'Sélectionner un département',
  btnSearchTests: 'Rechercher',
  demarcheStub: 'Inscrivez-vous pour accéder à cette étape de vos démarches',
  demarcheStubDesc: 'Inscrivez-vous pour voir le détail',
} as const;
